import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthLayoutComponent } from './auth-layout.component';
import { RouterModule, Routes } from '@angular/router';



@NgModule({
  declarations: [ AuthLayoutComponent ],
  imports: [
    CommonModule,
    RouterModule.forChild([]) 
  ],
  exports:[ AuthLayoutComponent]
})
export class AuthLayoutModule { }